import type { PropsWithChildren } from 'react';
import type React from 'react';

import { kebabCase } from 'lodash-es';

import { Card, Link, Text } from '@change/ds-core-ui';
import { ArrowRightFilledIcon } from '@change/ds-icons';

import { usePetitionSteps } from './hooks';

const Number: React.FC<PropsWithChildren> = ({ children }) => (
	<Text
		size="x-large"
		className="bg-fill-information-weaker text-typography-information h-10 w-10 rounded-full text-center leading-10"
	>
		{children}
	</Text>
);

const StepCard: React.FC<{
	title: string;
	description: string;
	number: number;
	articles: Array<{ title: string; slug: string }>;
}> = ({ title, description, number, articles }) => {
	return (
		<Card className="bg-background-base relative flex flex-col gap-6 p-6 md:flex-row md:gap-12 md:p-9">
			<div className="flex flex-col gap-6 md:w-2/3">
				<div className="flex flex-col items-start gap-4 md:flex-row md:items-center">
					<Number>{number}</Number>
					<Text variant="heading" fontWeight="bold">
						{title}
					</Text>
				</div>

				<Text className="md:text-lg">{description}</Text>
			</div>
			<div className="flex h-auto w-full flex-col justify-center gap-4 border-t border-l-0 pt-6 pl-0 md:w-1/3 md:border-t-0 md:border-l md:pt-0 md:pl-4">
				{articles.map((article) => (
					<Link
						key={article.slug}
						leadingIcon={<ArrowRightFilledIcon />}
						href={`/petition-guides/${article.slug}?source_location=petition_guides_landing_page`}
						data-qa={`${kebabCase(article.slug)}-link`}
					>
						{article.title}
					</Link>
				))}
			</div>
		</Card>
	);
};

export const PetitionSteps: React.FC = () => {
	const {
		data: { steps },
	} = usePetitionSteps();

	return (
		<div className="space-y-6">
			{steps.map((step, index) => (
				<StepCard key={step.title} {...step} number={index + 1} />
			))}
		</div>
	);
};
